module.exports = "<input appOnlyDecimal=\"true\" [(ngModel)]=\"params.value\" [disabled]=\"isDisable()\" (focusout)=\"onValueChange($event)\">"